import { required } from "react-admin";
import { ReferenceAutocompleteInput } from "ra-friendsofbabba";
import React from "react";

const UserResearcherInput = (props) => {
  return (
    <ReferenceAutocompleteInput
      {...props}
      reference="users"
      sort={{ field: "UserProfiles.surname", order: "DESC" }}
      validate={required()}
      filter={{
        roles: ["researcher"],
        assigned: false,
      }}
      optionText="name"
      helperText="resources.user-researcher-input.fields.help"
    />
  );
};

export default UserResearcherInput;
